module.exports = __webpack_public_path__ + "9b6e452a5a5c4b2bd8844f1c013497f5.svg";